var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart-container"},[_c('v-card',{staticClass:"chart-card",attrs:{"elevation":"0"}},[_c('div',{ref:"chart",staticClass:"chart-element"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }